import { Box } from '@mui/material';

const Pin = ({ width, height, sx = {}, ...props }) => {
  return (
    <Box
      component="svg"
      sx={{ width, height, ...sx }}
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.12185 30.9293L26.8781 30.9293C30.5803 30.9293 32.5 29.0839 32.5 25.5744L32.5 5.52217C32.5 1.99615 30.5803 0.167236 26.8781 0.167236L6.12185 0.167236C2.41966 0.167236 0.5 1.99615 0.5 5.52217L0.5 25.5744C0.5 29.1004 2.41966 30.9293 6.12185 30.9293ZM9.56695 18.6706C9.56695 16.8582 11.1438 14.9798 13.6119 14.123L13.9033 10.1851C12.6178 9.49307 11.6066 8.71866 11.1438 8.15845C10.8867 7.84539 10.7496 7.53234 10.7496 7.23575C10.7496 6.69202 11.1952 6.2801 11.8465 6.2801L21.2734 6.2801C21.9247 6.2801 22.3704 6.69202 22.3704 7.23575C22.3704 7.53234 22.2333 7.84539 21.9933 8.14197C21.5305 8.70218 20.5021 9.47659 19.2167 10.1851L19.4909 14.123C21.9762 14.9798 23.553 16.8582 23.553 18.6706C23.553 19.445 23.0217 19.9393 22.2161 19.9393L17.7598 19.9393L17.7598 22.9381C17.7598 24.6187 16.9028 26.2829 16.56 26.2829C16.2001 26.2829 15.3602 24.6187 15.3602 22.9381L15.3602 19.9393L10.9039 19.9393C10.0983 19.9393 9.56695 19.445 9.56695 18.6706Z"
        fill="#211915"
      />
    </Box>
  );
};

export default Pin;
